import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyMask'
})
export class CurrencyMaskPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      var formatted:string = '',
        x:number, lenX:number,
        newVal:any = value;

      if (!newVal) {
        newVal = 0;
      }

      if (typeof newVal == 'number') {
        newVal = newVal.toFixed(2);
      }
      newVal = newVal.toString();

      var point = newVal.indexOf(".");
      if (point === -1) {
        newVal = newVal + '00';
      } else {
        var afterPoint = newVal.slice(point + 1, newVal.length);
        if (afterPoint.length < 2) {
          newVal = newVal + '0';
        }
      }

      newVal = newVal.replace(".", "");

      if (newVal.length == 2) newVal = '0' + newVal;
      if (newVal.length == 1) newVal = '00' + newVal;

      for (x = 0, lenX = newVal.length; x < lenX; x++) {
        var sep = '';
        if (x == 2) sep = ',';
        if (x > 3 && (x + 1) % 3 == 0) sep = '.';
        formatted = newVal.substring(newVal.length - 1 - x, newVal.length - x) + sep + formatted;
      }

      newVal = formatted;

      return "R$ " + newVal;
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/currency-mask.pipe.ts
 **/